import { mergeWith, isArray } from "lodash/fp";

import createTheme from "./createTheme.jsx";

const mergeAndConcat = mergeWith((objValue, srcValue) => {
  if (isArray(objValue)) {
    return objValue.concat(srcValue);
  }
});

export default function mergeThemes(parentTheme, childTheme) {
  return createTheme(mergeAndConcat(parentTheme, childTheme));
}
